import { Link, Typography } from "@mui/material";

import { type FAQ } from "../../../../Components/FAQ/FAQAccordion";

export const PERFECTSCALE_FAQS: FAQ[] = [
  {
    question: "How is PerfectScale different from EKS and GKE Lens?",
    answer: (
      <Typography variant="body2" color="text.secondary">
        <span>
          Our EKS and GKE Lenses are out-of-the-box visibility solutions that help monitor and track Kubernetes costs
          and resource utilization.
        </span>
        <br />
        <br />
        <span>
          PerfectScale is a separate automation solution; it eliminates the manual effort of optimization by
          autonomously rightsizing your Kubernetes clusters for the best possible cost and performance.
        </span>
      </Typography>
    ),
  },
  {
    question: "Is PerfectScale included in my DoiT Cloud Intelligence plan?",
    answer:
      "No, while Kubernetes Lenses are included in our Enhanced and Enterprise plans, PerfectScale is an add-on solution that gets priced based on the size of your environment.",
  },
  {
    question:
      "If I have subscriptions to both DoiT Cloud Intelligence and PerfectScale, will I have separate user interfaces and logins for each one?",
    answer:
      "All DoiT customers who purchase PerfectScale for Kubernetes visibility and optimization will have a separate UI and login that is accessible from the DoiT console.",
  },
  {
    question: "Do I have to install an agent?",
    answer: (
      <Typography variant="body2" color="text.secondary">
        Yes; detailed instructions for doing so can be found in the{" "}
        <Link href="https://docs.perfectscale.io/" target="_blank" rel="noopener noreferrer" underline="hover">
          Help documentation
        </Link>
        .
      </Typography>
    ),
  },
  {
    question: "How is PerfectScale pricing calculated?",
    answer:
      "PerfectScale calculates the number of vCPU cores per month allotted across any cloud or self-hosted Kubernetes environments.",
  },
];

export const KUBERNETES_LENS_FAQS: FAQ[] = [
  {
    question: "What are Kubernetes Lens and PerfectScale? How are they different?",
    answer: (
      <Typography variant="body2" color="text.secondary">
        <span>
          Kubernetes Lens is an out-of-the-box visibility solution that helps monitor and track Kubernetes costs and
          resource utilization.
        </span>
        <br />
        <br />
        <span>
          PerfectScale is a separate automation solution powered by PerfectScale; it eliminates the manual effort of
          optimization by autonomously rightsizing your Kubernetes clusters for the best possible cost and performance.
        </span>
      </Typography>
    ),
  },
  {
    question: "Is Kubernetes Lens included in my DoiT Cloud Intelligence plan?",
    answer:
      "Yes, Kubernetes Lens is included in our Enhanced and Enterprise plans. You can also access PerfectScale as an add-on solution that gets priced based on the size of your environment.",
  },
  {
    question: "Do I have to install an agent?",
    answer:
      "Yes, Kubernetes Lens runs off an agent that can be deployed in your K8s environment. Detailed instructions for doing so can be found in our Help documentation [link doesnt exist yet]",
  },
  {
    question: "What permissions are required to start using this feature?",
    answer: "[Answer TBD]",
  },
];
